import React from 'react';

const Mensaje = () => {

    return (
        <ul className="dropdown-menu">
            <li>
                <p>Debe seleccionar usuarios con el mismo estado</p>
            </li>
        </ul>

    );


}



const BotonRecuperar = (props) => {

    let usuariosSeleccionados;
    let Recuperados;

    if (props.usuariosFiltrados != undefined) {
        usuariosSeleccionados = props.usuariosFiltrados.filter(x => x.Seleccionado == true).length;
        Recuperados = props.usuariosFiltrados.filter(x => x.Seleccionado == true && x.Activo == true || x.Seleccionado == true && x.Bloqueado == true).length;
    }
    
    return (
        <div className="dropdown">
            <button className="btn btn-icon btn-trash"
                disabled={!(usuariosSeleccionados > 0)}
                title="Recuperar los seleccionados" data-toggle="dropdown"
                onClick={(Recuperados >= 1)?null:() => props.setUserState(null, true, false)}>
                <span className="ti-export"></span>
            </button>
            {(Recuperados >= 1) ? <Mensaje /> : null}
        </div>
        
        );

}

export default BotonRecuperar;